<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl relative">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients')">Klienci</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients.show', client.id)">{{ client.firma ? client.firma.NAZWA_PELNA : client.nazwa_pelna }}</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      Adresy firmy

      <div class="mb-6 flex justify-between items-center">
        <inertia-link class="btn-shtax ml-auto absolute right-0 top-0 disabled:opacity-50" :href="route('clients.address.create', client.id)"  v-if="$page.props.can['add clients address']">
          <span>Nowy</span>
          <span class="hidden md:inline">adres</span>
        </inertia-link>
      </div>
    </h1>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap text-xs">
        <tr class="text-left font-bold">
          <th class="px-3 pt-6 pb-4">Data od</th>
          <th class="px-3 pt-6 pb-4">Kraj</th>
          <th class="px-3 pt-6 pb-4">Województwo</th>
          <th class="px-3 pt-6 pb-4">Powiat</th>
          <th class="px-3 pt-6 pb-4">Gmina</th>
          <th class="px-3 pt-3 pb-2">Miejscowość</th>
          <th class="px-3 pt-6 pb-4">Kod<br>pocztowy</th>
          <th class="px-3 pt-6 pb-4">Ulica</th>
          <th class="px-3 pt-3 pb-2">Numer<br>domu/lokalu</th>
          <th class="px-3 pt-6 pb-4">Typ</th>
          <th class="px-3 pt-3 pb-2" colspan="2">US</th>
        </tr>
        <tr v-for="address in client.firma.adresy" :key="address.ID_ADRESY_FIRMY" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.address.edit', {'client':client.id, 'address':address.ID_ADRESY_FIRMY})">
              {{ address.DATA_OD }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.address.edit', {'client':client.id, 'address':address.ID_ADRESY_FIRMY})">
              {{ address.SYM_KRAJU }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.address.edit', {'client':client.id, 'address':address.ID_ADRESY_FIRMY})">
              {{ address.WOJEWODZTWO }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.address.edit', {'client':client.id, 'address':address.ID_ADRESY_FIRMY})">
              {{ address.POWIAT }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.address.edit', {'client':client.id, 'address':address.ID_ADRESY_FIRMY})">
              {{ address.GMINA }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.address.edit', {'client':client.id, 'address':address.ID_ADRESY_FIRMY})">
              {{ address.MIEJSCOWOSC }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.address.edit', {'client':client.id, 'address':address.ID_ADRESY_FIRMY})">
              {{ address.KOD_POCZTOWY }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.address.edit', {'client':client.id, 'address':address.ID_ADRESY_FIRMY})">
              {{ address.ULICA }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.address.edit', {'client':client.id, 'address':address.ID_ADRESY_FIRMY})">
              {{ address.NR_DOMU }}/{{ address.NR_LOKALU }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.address.edit', {'client':client.id, 'address':address.ID_ADRESY_FIRMY})">
              {{ address.TYP_ADRESU }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.address.edit', {'client':client.id, 'address':address.ID_ADRESY_FIRMY})">
              {{ address.urzad ? address.urzad.NAZWA : '' }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.address.edit', {'client':client.id, 'address':address.ID_ADRESY_FIRMY})">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="client.firma.adresy.length === 0">
          <td class="border-t px-3 py-2" colspan="8">Brak adresów firmy {{ client.firma ? client.firma.NAZWA_PELNA : client.nazwa_pelna }}.</td>
        </tr>
      </table>
    </div>

    <h2 class="mt-12 font-bold text-xl md:text-2xl">
      Dane adresowe w kontrahencie
    </h2>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap text-xs">
        <tr class="text-left font-bold">
          <th class="px-3 pt-6 pb-4">Kraj</th>
          <th class="px-3 pt-6 pb-4">Województwo</th>
          <th class="px-3 pt-6 pb-4">Powiat</th>
          <th class="px-3 pt-3 pb-2">Miejscowość</th>
          <th class="px-3 pt-6 pb-4">Kod<br>pocztowy</th>
          <th class="px-3 pt-6 pb-4">Ulica lokal</th>
        </tr>
        <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.contractor.address.edit', {'client':client.id, 'contractor':client.kontrahent.ID_KONTRAHENTA})">
              {{ client.kontrahent.SYM_KRAJU }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.contractor.address.edit', {'client':client.id, 'contractor':client.kontrahent.ID_KONTRAHENTA})">
              {{ client.kontrahent.WOJEWODZTWO }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.contractor.address.edit', {'client':client.id, 'contractor':client.kontrahent.ID_KONTRAHENTA})">
              {{ client.kontrahent.POWIAT }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.contractor.address.edit', {'client':client.id, 'contractor':client.kontrahent.ID_KONTRAHENTA})">
              {{ client.kontrahent.MIEJSCOWOSC }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.contractor.address.edit', {'client':client.id, 'contractor':client.kontrahent.ID_KONTRAHENTA})">
              {{ client.kontrahent.KOD_POCZTOWY }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.contractor.address.edit', {'client':client.id, 'contractor':client.kontrahent.ID_KONTRAHENTA})">
              {{ client.kontrahent.ULICA_LOKAL }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.contractor.address.edit', {'client':client.id, 'contractor':client.kontrahent.ID_KONTRAHENTA})">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'

export default {
  metaInfo: { title: 'Adresy firmy' },
  components: {
    Icon
  },
  layout: Layout,
  props: {
    client: Object
  },
  data() {
    return {
    }
  }
}
</script>
